import famousBabyResultChange from './actions/famousBabyResultChange';
import famousBabyResultCreate from './actions/famousBabyResultCreate';
import famousBabyResultDetail from './actions/famousBabyResultDetail';
import famousBabyResultList from './actions/famousBabyResultList';
import famousBabyResultListUpload from './mutations/famousBabyResultListUpload';
import getFamousBabyResultItems from './getters/getFamousBabyResultItems';

const actions = {
  famousBabyResultChange,
  famousBabyResultCreate,
  famousBabyResultDetail,
  famousBabyResultList,
};

const mutations = {
  famousBabyResultListUpload
};

const getters = {
  getFamousBabyResultItems
}

export default { actions, mutations, getters}